export default __webpack_public_path__ + "static/media/linkedinLogo.ed0cec1b.png";